import { Button, Checkbox, Input, Spin } from "antd";
import Form from "antd/lib/form";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import "./index.css";
import { useState } from "react";

export const LoginForm = ({
  authFunc,
}: {
  authFunc: (
    // eslint-disable-next-line no-unused-vars
    login: string,
    // eslint-disable-next-line no-unused-vars
    password: string,
    // eslint-disable-next-line no-unused-vars
    remember: boolean,
    // eslint-disable-next-line no-unused-vars
    setLoading?: any
  ) => Promise<void>;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const onFinish = async (values: { [index: string]: string }) => {
    const { login, password, remember } = values;
    authFunc(login, password, !!remember, setLoading);
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ margin: "auto" }}>
        <Spin spinning={loading}>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            style={{ width: 500 }}
            onFinish={onFinish}
          >
            <Form.Item
              name="login"
              rules={[
                {
                  required: true,
                  message: "Введите логин",
                },
              ]}
            >
              <Input
                size="large"
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Логин"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Введите пароль",
                },
              ]}
            >
              <Input
                size="large"
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Пароль"
              />
            </Form.Item>
            <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Запомнить</Checkbox>
              </Form.Item>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Войти
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </div>
  );
};
